import React, { Fragment, useState } from 'react';
import I18n from '../../config/locales/e_i18n';
import { connect } from 'react-redux';
import { Route } from 'react-router-dom';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import { Box, Backdrop, Button, Grid, Drawer } from '@material-ui/core';
import queryString from 'query-string';
import { DefaultHeader } from '../../components/common/Header';
import { Footer, FooterWithoutLanguageSwitch } from '../../components/common/Footer';
import {
  forwardTo,
  setToken,
  decodeToken,
  getToken,
  handleFeedbackMenu,
  getBelongsTo,
  constructQueryString
} from '../../utils/helper';
import { get, isEqual, isEmpty } from '../../utils/lodash';
import {
  setCompanyId,
  setMobileView,
  getCompanyInfo,
  setIsAdmin,
  setEnlightenManagerToken,
  getABFeatureList,
  setNoticeHeight,
  getBannerData,
  getUserDetails
} from './actions';
import LeadLeftPanelAccordion from '../../components/LeftPanelAccordion';
import Breadcrumbs from '../../components/common/Breadcrumbs';
import Loader from '../../components/Loader';
import { getAccountData } from '../AccountDetails/actions';
import analytics from '../../utils/analytics';
import { getUserOwnPreferences } from '../Preferences/actions';
import getMoment from '../../components/common/moment';
import LoggedAs from '../../components/LoggedAs';
import BannerAlert from '../../components/BannerAlert';
import { getAllTemplates } from '../LeadManagement/actions';
import FooterWithoutLanguageSwitchSG from '../../components/common/Footer/footerWithoutLanguageSwitchSG';
import GoogleAnalytics from '../../utils/GoogleAnalytics/googleAnalytics4';
import settings from '../../utils/settings';

const useStyles = makeStyles(theme => ({
  root: {
    // height: '100%'
  },
  body: {
    marginTop: theme.spacing(7)
  },
  mobileBody: {
    marginTop: theme.spacing(6.25)
    // height: '100%'
  },
  backdrop: {
    zIndex: 11,
    color: theme.palette.primary.main
  },
  systemMenuButton: {
    border: 'none',
    fontWeight: 'bold',
    textTransform: 'capitalize',
    fontSize: 16,
    background: '#FAFAFA 0% 0% no-repeat padding-box',
    boxShadow: '0px 0px 15px #0000001a',
    margin: theme.spacing(0.75),
    position: 'fixed',
    zIndex: 1,
    '&:hover': {
      border: 'none',
      background: 'none'
    }
  },
  rightContainer: {
    // height: '100%'
  },
  rightBody: {
    width: 'calc(100% - 280px)',
    marginLeft: theme.spacing(35)
  },
  childRightBody: {
    padding: theme.spacing(0, 4, 2.5)
  },
  childRightBodySolargraf: {
    padding: theme.spacing(0, 2)
  },
  solargrafIframeRightBody: {
    paddingBottom: 0
    // height: '100%'
  },
  mobileRightBody: {
    width: '100%',
    marginLeft: theme.spacing(0),
    marginTop: theme.spacing(6)
  },
  childMobileRightBody: {
    padding: theme.spacing(0, 2, 2.5)
  },
  leftAccordion: {
    padding: '0 !important',
    borderRight: '0.5px solid #3359773d',
    background: '#FFFFFF 0% 0% no-repeat padding-box',
    boxShadow: '0px 0px 15px #0000001A',
    position: 'fixed',
    overflowY: 'auto',
    scrollBehavior: 'smooth',
    height: 'calc(100% - 56px)'
  },
  mobileLeftAccordion: {
    height: 'calc(100% - 45px)'
  },
  isMobileLeftAccordion: {
    position: 'relative',
    height: '100%'
  },
  footerSolargrafLeftPanel: {
    width: '260px',
    paddingLeft: '15px'
  },
  solargrafIframe: {
    // height: '100%',
    overflow: 'hidden'
  },
  paddingFooterSolargraf: {
    padding: theme.spacing(1.5, 0)
  }
}));

const Layout = ({
  children,
  isMobileView,
  currentlySending,
  matchProps,
  companyId,
  accountDetail,
  leadId,
  preferencesData,
  isUnauthorized,
  accountLoading,
  isAdmin,
  companyInfo,
  enlightenManagerToken,
  belongsToAus,
  company,
  belongsToUs,
  withoutFooter,
  isMobile,
  hasLeftPane,
  setNoticeHeight,
  bannerNotice,
  currentlySendingForUserOwn,
  fromITK,
  isFromSolargraf,
  ...rest
}) => {
  const classes = useStyles();
  const [ isLeftPaneOpen, setIsLeftPaneOpen ] = useState(false);
  const isLoading = accountLoading || isUnauthorized || currentlySending || currentlySendingForUserOwn;
  const leftPaneAccordion = (
    <Grid
      className={clsx(
        classes.leftAccordion,
        isMobileView && classes.mobileLeftAccordion,
        isMobile && classes.isMobileLeftAccordion
      )}
    >
      <LeadLeftPanelAccordion
        isLeftPaneOpen={isLeftPaneOpen}
        isMobile={isMobile}
        closeLeftPanel={() => setIsLeftPaneOpen(false)}
        {...matchProps}
      />
      {isFromSolargraf && (
        <Box className={classes.footerSolargrafLeftPanel}>
          <FooterWithoutLanguageSwitchSG />
        </Box>
      )}
    </Grid>
  );

  const getLeadBody = isFromSolargraf => {
    return (
      <Fragment>
        {!fromITK && <DefaultHeader isAdmin={isAdmin} {...matchProps} />}
        {accountLoading || isUnauthorized || currentlySendingForUserOwn ? (
          <Loader loading />
        ) : (
          <Box className={clsx(fromITK ? {} : isMobileView ? classes.mobileBody : classes.body)}>
            <Box className={classes.root}>
              {!hasLeftPane ? (
                <Fragment>
                  <LoggedAs accountDetail={accountDetail} />
                  {!isEmpty(bannerNotice) && (
                    <BannerAlert bannerNotice={bannerNotice} setNoticeHeight={setNoticeHeight} />
                  )}
                  {!fromITK && <Breadcrumbs matchProps={matchProps} />}
                  <Fragment>{children}</Fragment>
                </Fragment>
              ) : (
                <Fragment>
                  {isMobile && (
                    <Button
                      className={classes.systemMenuButton}
                      color="primary"
                      variant="outlined"
                      onClick={() => setIsLeftPaneOpen(true)}
                    >
                      System Menu
                    </Button>
                  )}
                  <Grid container direction="row" className={classes.rightContainer}>
                    {isMobile ? (
                      <Drawer anchor="left" open={isLeftPaneOpen} onClose={() => setIsLeftPaneOpen(false)}>
                        {leftPaneAccordion}
                      </Drawer>
                    ) : (
                      leftPaneAccordion
                    )}
                    <Grid
                      className={clsx(
                        classes.rightBody,
                        isFromSolargraf && classes.solargrafIframeRightBody,
                        isMobile && classes.mobileRightBody
                      )}
                    >
                      <LoggedAs accountDetail={accountDetail} />
                      {!isEmpty(bannerNotice) && (
                        <BannerAlert bannerNotice={bannerNotice} setNoticeHeight={setNoticeHeight} />
                      )}
                      {!fromITK && <Breadcrumbs matchProps={matchProps} />}
                      <Box
                        className={clsx(
                          classes.childRightBody,
                          isFromSolargraf && classes.childRightBodySolargraf,
                          isMobile && !isFromSolargraf && classes.childMobileRightBody
                        )}
                      >
                        {children}
                      </Box>
                    </Grid>
                  </Grid>
                </Fragment>
              )}
            </Box>
          </Box>
        )}
        {!fromITK && !withoutFooter && <Footer />}
        {isLoading && <Backdrop className={classes.backdrop} open />}
      </Fragment>
    );
  };

  return (
    <Fragment>
      {isFromSolargraf ? <Box className={classes.solargrafIframe}>{getLeadBody(true)}</Box> : getLeadBody()}
    </Fragment>
  );
};

class DigiCore extends React.Component {
  constructor(props) {
    super(props);
    const { search, pathname } = props.location;
    const { token, ...remainingQuery } = queryString.parse(search);
    this.isAdmin = get(remainingQuery, 'isAdmin', false) || false;
    const { company_id } = this.getCompanyUserId(token, pathname);
    const { is_distributor } = this.getIsDistributor(token, pathname);
    const companyIdFromParam = get(props, 'computedMatch.params.companyId');
    const companyId = companyIdFromParam ? companyIdFromParam : company_id;

    if (token && pathname) {
      setToken(token);
      const queryString = constructQueryString(remainingQuery);
      const forwardPathname = `${pathname}${queryString}`;
      forwardTo(forwardPathname);
    }
    if (token) this.props.setEnlightenManagerToken(token);

    if (is_distributor && !pathname.includes('/manager/dashboard/account-details') && !pathname.includes('/manager/dashboard/error')){
      window.location = '/manager/dashboard/distributor-dashboard';
    }
    
    // This change is done because user refreshes on solargraf quote and his preferences gets reset in reducer
    // so it seems like he doesnt have access to solargraf even though he has it
    // That is why this api is required to be called first and a loader is to be shown until it is successful
    // This change should be propagated to DRS although not necessary
    this.props.getUserOwnPreferences();
    this.props.setCompanyId(companyId);
    this.props.getAccountData({ successCbk: () => this.accountSuccessCbk(companyId) });
    const googleAnalytics =new GoogleAnalytics()
    const environments= settings.getConfig()
    googleAnalytics.setEnvironment(environments.env)
    this.analytics = new analytics();
    this.state = {
      isMobile: window.innerWidth < 1024
    };
  }

  accountSuccessCbk(companyId) {
    const { accountDetail, getBannerData, getABFeatureList, getAllTemplates } = this.props;
    const { from } = queryString.parse(get(this.props, 'history.location.search', ''));
    if (from === 'bom-dialog') {
      getAllTemplates();
    }
    this.companyInfo(companyId);
    getABFeatureList({ email: accountDetail.email, companyId: accountDetail.company_id });
    getBannerData();
    const installerName = get(accountDetail, 'first_name', '') + ' ' + get(accountDetail, 'last_name', '');
    this.analytics.setUserId(accountDetail.user_id, installerName, companyId);
  }

  companyInfo = companyId => {
    const { accountDetail, getUserDetails } = this.props;
    const isUser = accountDetail && accountDetail.roles && isEqual(accountDetail.roles, []) === true;
    const companyIdFromParam = get(this.props, 'computedMatch.params.companyId');
    // give highest priority to companyIdFromParam as if I sign in as alpha solar and go to their branch i should their branch info
    companyId = companyIdFromParam ? companyIdFromParam : accountDetail.login_as ? accountDetail.company_id : companyId;
    this.props.setCompanyId(companyId);
    getUserDetails();
    !isUser && this.props.getCompanyInfo(companyId);
  };

  getCompanyUserId = (token = '') => {
    const tokenValue = token || getToken();
    const { company_id } = decodeToken(tokenValue);
    return { company_id };
  };

  getIsDistributor = (token = '') => {
    const tokenValue = token || getToken();
    const { is_distributor } = decodeToken(tokenValue);
    return { is_distributor };
  };

  UNSAFE_componentWillMount() {
    window.addEventListener('resize', this.handleWindowSizeChange);
  }

  handleWindowSizeChange = () => {
    const isMobileView = window.innerWidth <= 1200;
    this.setState({ isMobile: window.innerWidth < 1024 });
    this.props.setMobileView(isMobileView);
  };

  componentDidUpdate = prevProps => {
    handleFeedbackMenu(this.props);
    I18n.defaultLocale = 'en';
    I18n.locale = this.props.locale || '';
    I18n.fallbacks = true;
    getBelongsTo(this.props.countryCode);
    getMoment(this.props.locale);
  };

  componentDidMount = () => {
    this.handleWindowSizeChange();
    if (this.props.isAdmin || this.isAdmin === 'true') {
      this.props.setIsAdmin(true);
    } else {
      this.props.setIsAdmin(false);
    }
  };

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleWindowSizeChange);
  }

  render() {
    const {
      component: Component,
      isMobileView,
      currentlySending,
      companyId,
      accountDetail,
      leadId,
      preferencesData,
      isUnauthorized,
      accountLoading,
      isAdmin,
      companyInfo,
      company,
      belongsToAus,
      belongsToUs,
      enlightenManagerToken,
      withoutFooter = false,
      hasLeftPane = false,
      setNoticeHeight,
      bannerNotice,
      currentlySendingForUserOwn,
      fromITK,
      ...rest
    } = this.props;
    const { isMobile } = this.state;
    const { search } = this.props.location;
    const { leadView = '' } = queryString.parse(search);

    return (
      <Route
        {...rest}
        render={matchProps => (
          <Layout
            isMobileView={isMobileView}
            currentlySending={currentlySending}
            companyId={companyId}
            matchProps={matchProps}
            leadId={leadId}
            accountDetail={accountDetail}
            preferencesData={preferencesData}
            isUnauthorized={isUnauthorized}
            accountLoading={accountLoading}
            isAdmin={isAdmin}
            enlightenManagerToken={enlightenManagerToken}
            belongsToAus={belongsToAus}
            company={company}
            belongsToUs={belongsToUs}
            withoutFooter={withoutFooter}
            isMobile={isMobile}
            hasLeftPane={hasLeftPane}
            setNoticeHeight={setNoticeHeight}
            bannerNotice={bannerNotice}
            currentlySendingForUserOwn={currentlySendingForUserOwn}
            fromITK={fromITK}
            isFromSolargraf={leadView === 'solargraf'}
          >
            <Component {...matchProps} />
          </Layout>
        )}
      />
    );
  }
}

const mapDispatchToProps = dispatch => ({
  setCompanyId: companyId => dispatch(setCompanyId(companyId)),
  getCompanyInfo: companyId => dispatch(getCompanyInfo(companyId)),
  setMobileView: isMobileView => dispatch(setMobileView(isMobileView)),
  getAccountData: payloads => dispatch(getAccountData(payloads)),
  setIsAdmin: isAdmin => dispatch(setIsAdmin(isAdmin)),
  setEnlightenManagerToken: tokenVal => dispatch(setEnlightenManagerToken(tokenVal)),
  getABFeatureList: payload => dispatch(getABFeatureList(payload)),
  setNoticeHeight: noticeHeight => dispatch(setNoticeHeight(noticeHeight)),
  getBannerData: () => dispatch(getBannerData()),
  getUserOwnPreferences: () => dispatch(getUserOwnPreferences()),
  getUserDetails: () => dispatch(getUserDetails()),
  getAllTemplates: () => dispatch(getAllTemplates())
});

const mapStateToProps = state => ({
  isMobileView: state.appReducer.isMobileView,
  companyId: state.appReducer.companyId,
  currentlySending: state.appReducer.currentlySending,
  accountDetail: state.accountReducer.accountDetail,
  isUnauthorized: state.accountReducer.isUnauthorized,
  accountLoading: state.accountReducer.currentlySending,
  bannerNotice: state.appReducer.bannerNotice,
  isAdmin: state.appReducer.isAdmin,
  preferencesData: state.preferencesReducer.preferencesData,
  companyInfo: state.appReducer.companyInfo,
  enlightenManagerToken: state.appReducer.enlightenManagerToken,
  belongsToAus: state.appReducer.belongsToAus,
  company: state.appReducer.company,
  belongsToUs: state.appReducer.belongsToUs,
  locale: state.accountReducer.locale,
  countryCode: state.appReducer.countryCode,
  currentlySendingForUserOwn: state.preferencesReducer.currentlySendingForUserOwn,
  fromITK: state.appReducer.fromITK
});

export default connect(mapStateToProps, mapDispatchToProps)(DigiCore);
